export enum Environment {
  Uat = 'uat',
  ProdLke = 'prodLike',
  Development = 'development',
  Testing = 'testing',
  Production = 'production',
}

export const getCurrentEnvironment = (): Environment => {
  const isUAT = process.env.UAT_COOKIE && document.cookie.indexOf(process.env.UAT_COOKIE) !== -1;
  const isAnyUAT = document.cookie.indexOf('UAT') !== -1;
  const isProdLike =
    process.env.PRODLIKE_COOKIE && document.cookie.indexOf(process.env.PRODLIKE_COOKIE) !== -1;
  const isTest = /webtest/.test(window.location.hostname);

  if (isUAT) return Environment.Uat;
  if (isProdLike) return Environment.ProdLke;
  if (isAnyUAT) return Environment.Testing;
  if (isTest) return Environment.Testing;
  return process.env.NODE_ENV === 'production' ? Environment.Production : Environment.Development;
};

export const parseEnv = <Key extends string>(
  key: Key,
): Key extends 'true' | 'false' ? boolean | undefined : string | undefined => {
  try {
    return JSON.parse(key);
  } catch {
    // @ts-expect-error idk
    return key || undefined;
  }
};
